/**
 * Created by slava on 4/21/17.
 */

const VKSocial = function () {
    Social.MAX_INVITE_RANDOM_FRIENDS = 1;
    this._isLegacyApp = connector.utils.getRequestParameters().viewer_id !== undefined;

    Social.call(this, connector.VK, {
        sdk: SdkManager.SDK_VK
    });
};

VKSocial.prototype = Object.create(Social.prototype);
VKSocial.prototype.constructor = VKSocial;

VKSocial.prototype._connect = function (callback) {
    connector.platform.whenConnected(() => {
        callback(connector.STATUS_CONNECTED);
    });
};

VKSocial.prototype.isShareSupported = function () {
    return true;
};

VKSocial.prototype.isInviteSupported = function () {
    return true;
};

VKSocial.prototype.isSupportsNativeRequest = function () {
    return true;
};

VKSocial.prototype.sendActivity = function (data, callback) {
    const params = {
        user_id: connector.platform.getUserID(),
        v: VKPlatform.API_VERSION
    };

    params.activity_id = data.activityId;
    if (data.value) {
        params.value = data.value;
    }

    ConnectorRestClient.get("/vkappevents", {}, () => {
        callback(connector.CODE_SUCCEED);
    }, () => {
        callback(connector.CODE_FAILED);
    }, {
        queryParams: params
    });
};

VKSocial.prototype.markAchievement = function (data) {
    if (data.vkId !== undefined) {
        this.sendActivity({
            activityId: data.vkId
        }, () => {});
    }
};

VKSocial.prototype.isLoggedIn = function () {
    return true;
};

VKSocial.prototype._getUserID = function () {
    const params = connector.utils.getRequestParameters();
    return this._isLegacyApp ? params.viewer_id : params.vk_user_id;
};

VKSocial.prototype.getAccessTokenPrefix = function () {
    return "VK_";
};

VKSocial.prototype.getAccessToken = function () {
    const prefix = this.getAccessTokenPrefix();
    const params = connector.utils.getRequestParameters();
    if (this._isLegacyApp) {
        return `${prefix}${params.auth_key}`;
    }

    let query = [];
    for (const key in params) {
        if (typeof params[key] === "string" && key.startsWith("vk_")) {
            query.push({ key, value: params[key] });
        }
    }

    query = query.sort((a, b) => a.key.localeCompare(b.key)).reduce((acc, item, ind) => `${acc + (ind === 0 ? "" : "&") + item.key}=${encodeURIComponent(item.value)}`, "");

    return `${prefix}${params.sign}_query_${query}`;
};

VKSocial.prototype._login = function (callback) {
    callback();
};

VKSocial.prototype.invite = function (data, callback) {
    connector.platform.callNative("VKWebAppShowInviteBox", {}, callback);
};

VKSocial.prototype.requestToOne = function (uid, data, callback) {
    connector.platform.callNative("VKWebAppShowRequestBox", {
        uid: parseInt(uid),
        message: data.text,
        requestKey: "key"
    }, callback);
};

VKSocial.prototype.request = function (data, callback) {
    let to = data.to;
    if (!Array.isArray(to)) {
        to = [to];
    }

    const sended = [];
    const sendOneRequest = function (id) {
        if (id === to.length) {
            callback(sended.length > Math.floor(to.length / 2) ? connector.CODE_SUCCEED : connector.CODE_CANCELLED, sended);
        } else {
            this.requestToOne(to[id], data, (response) => {
                if (response === connector.CODE_SUCCEED) {
                    sended.push(to[id]);
                }
                sendOneRequest(id + 1);
            });
        }
    }.bind(this);
    sendOneRequest(0);
};

VKSocial.prototype.share = function (data, callback) {
    connector.platform.callNative("VKWebAppShowStoryBox", {
        background_type: "image",
        url: data.image,
        attachment: {
            text: "open",
            type: "url",
            url: `https://vk.ru/app${connector.config[connector.info.source].appId}`
        },
        stickers: [{
            sticker_type: "native",
            sticker: {
                action_type: "text",
                action: {
                    text: data.text,
                    style: "classic",
                    background_style: "none",
                    selection_color: "#FFFFFF",
                    alignment: "center"
                },
                transform: {
                    gravity: "center_bottom"
                }
            }
        }]
    }, callback);
};

VKSocial.prototype.hasLeaderBoard = function () {
    return connector.info.isMobile;
};

VKSocial.prototype.showLeaderBoard = function (options, callback) {
    connector.platform.callNative("VKWebAppShowLeaderBoardBox", {
        user_result: options.userResult
    }, callback);
};

VKSocial.prototype.askFriendsPermission = function (callback) {
    connector.platform.getPlugin().askPermissions("friends", callback);
};

VKSocial.prototype.listFriendsByApp = function (inApp, callback) {
    const getAppFriendsCb = function (code, appData) {
        if (code !== connector.CODE_SUCCEED) {
            callback(connector.CODE_FAILED, []);
            return;
        }

        if (!appData || !appData.response || !appData.response.map) {
            callback(connector.CODE_FAILED, []);
            return;
        }

        const appIds = appData.response.map(VKSocial.prepareId);

        connector.platform.callNative("friends.get", {
            count: 1000,
            fields: "photo_200"
        }, (code, data) => {
            if (code !== connector.CODE_SUCCEED) {
                callback(connector.CODE_FAILED, []);
                return;
            }

            callback(connector.CODE_SUCCEED, this.prepareFriendsData(data.response && data.response.items, appIds, inApp));
        });
    }.bind(this);

    connector.platform.callNative("friends.getAppUsers", {}, getAppFriendsCb);
};

VKSocial.prototype.prepareFriendsData = function (friendsData, appIds, inApp) {
    const friends = (friendsData || []).filter((friend) => friend.deactivated === undefined);

    return friends.map(VKSocial.formatUserData).filter((friend) => inApp === (appIds.indexOf(friend.id) !== -1));
};

VKSocial.prototype._listFriends = function (callback) {
    this.listFriendsByApp(true, callback);
};

VKSocial.prototype._listInvitableFriends = function (callback) {
    this.listFriendsByApp(false, callback);
};

VKSocial.prototype._aboutMe = function (callback) {
    // console.log("about me");
    connector.platform.callNative("VKWebAppGetUserInfo", {}, (code, data) => {
        // console.log("about me", code, data);
        if (code === connector.CODE_SUCCEED) {
            callback(connector.CODE_SUCCEED, VKSocial.formatUserData(data));
        } else {
            callback(connector.CODE_FAILED);
        }
    });
};

VKSocial.prepareId = function (uid) {
    return `${uid}`;
};

VKSocial.formatUserData = function (user) {
    return {
        id: VKSocial.prepareId(user.id),
        name: `${user.first_name} ${user.last_name}`,
        firstName: user.first_name,
        lastName: user.last_name,
        avatar: (user.photo_200 && user.photo_200.indexOf("camera_200.png") === -1) ? user.photo_200 : undefined
    };
};

VKSocial.DEFAULT_HEIGHT = 720;
VKSocial.DEFAULT_WIDTH = 800;
VKSocial.MIN_HEIGHT = 480;
VKSocial.SCREEN_HEIGHT_RESERVED = 230;
